export default __webpack_public_path__ + "static/media/burial-site.fdc547fe.svg";